import BaseAPI from '@/apis/base/baseApi';

export default class SumaryApi extends BaseAPI {
  apiName = 'SU';
}
